@if (formulario) {
  <ng-container [formGroup]="formulario">
    <!-- Identidad (white-label): la app se resuelve por estos. Inmutable por build. -->
    <div class="subgrupo">
      <h2>Identidad</h2>

      <mat-form-field>
        <mat-label>Nombre APP Mobile</mat-label>
        <input
          matInput
          placeholder="Nombre de la aplicación mobile"
          formControlName="nombreAppMobile"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Bundle ID Android</mat-label>
        <input
          matInput
          placeholder="com.gpesistemas.mialertaquilmes"
          formControlName="bundleIdAndroid"
        />
        <mat-hint
          >Se usa para el provisioning del build (resuelve el cliente): cambialo
          con cuidado</mat-hint
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>Bundle ID iOS</mat-label>
        <input
          matInput
          placeholder="ar.gpesistemas.mialertaquilmes"
          formControlName="bundleIdIOS"
        />
        <mat-hint
          >Se usa para el provisioning del build (resuelve el cliente): cambialo
          con cuidado</mat-hint
        >
      </mat-form-field>
    </div>

    <!-- Layout de la pantalla de ingreso (a nivel cliente) -->
    <div class="subgrupo">
      <h2>Pantalla de login</h2>
      <div class="row-wrap justify-start gap-15px">
        <!-- Columna izquierda: selección -->
        <div class="flex-1" style="min-width: 280px">
          <mat-form-field style="width: 100%">
            <mat-label>Plantilla de login</mat-label>
            <mat-select formControlName="loginTemplate">
              @for (o of loginOpciones; track o.id) {
                <mat-option [value]="o.id">{{ o.label }}</mat-option>
              }
            </mat-select>
            <mat-hint
              >Layout de la pantalla de ingreso (a nivel cliente)</mat-hint
            >
          </mat-form-field>
        </div>

        <!-- Columna derecha: preview en vivo. Custom → solo login (la botonera no se previsualiza). -->
        <div style="flex: 0 0 360px; max-width: 100%">
          <app-provisionador-preview
            [vm]="previewVm"
            [soloLogin]="true"
          ></app-provisionador-preview>
        </div>
      </div>
    </div>

    <!-- Familia de botonera que usan las categorías que no traen una propia. -->
    <div class="subgrupo">
      <h2>Plantilla base del cliente</h2>
      <mat-form-field style="width: 100%">
        <mat-label>Plantilla del cliente (id)</mat-label>
        <input matInput formControlName="inicioTemplate" />
        <mat-hint>
          Genérica (grid/banner/centrado/hub) = botonera por categoría · id
          custom (ej. "almirante brown") = template hecho a mano por bundleId
        </mat-hint>
      </mat-form-field>

      @if (clienteEsCustom) {
        <p class="mat-hint" style="margin: 4px 0 0">
          Template <strong>custom</strong> (<code>{{ inicioTemplateCliente }}</code
          >) por bundleId: la botonera es hecha a mano y no se previsualiza ni se
          elige acá. La variación por categoría sale del nombre del template de
          cada categoría.
        </p>
      } @else {
        <p class="mat-hint" style="margin: 4px 0 0">
          Cada categoría puede pisarla con su propia botonera (pestaña
          Categorías).
        </p>
      }

      <!-- Editor de categorías (mismo del provisionador): solo para clientes genéricos. -->
      @if (clienteEsGenerico && categoriasEditables.length) {
        <h3 class="mt-3">Categorías</h3>
        <p class="mat-hint" style="margin: 0 0 8px">
          Reordená botones, cambiá la plantilla o las imágenes de cada
          categoría. Se guarda con el cliente.
        </p>
        @for (ed of categoriasEditables; track ed.idCategoria) {
          <mat-expansion-panel class="cat-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                ed.grupo.get("nombre")?.value || ed.idCategoria
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <app-categoria-editor
              [grupo]="ed.grupo"
              [botones]="ed.botones"
              [idsPrincipales]="ed.idsPrincipales"
              [idsSecundarios]="ed.idsSecundarios"
              [idsOtros]="ed.idsOtros"
              [imagenes]="ed.imagenes"
              [idCategoria]="ed.idCategoria"
              [nombreCliente]="nombreCliente"
              [clienteFormValue]="formulario.value"
              [sirenas]="sirenas"
            ></app-categoria-editor>
          </mat-expansion-panel>
        }
      }
    </div>

    <!-- Branding (white-label): color de marca → paleta Material; fuente propia; logos -->
    <div class="subgrupo">
      <h2>Branding</h2>

      <div
        class="row justify-start align-center gap-3"
        [formGroup]="configuracion"
      >
        <mat-form-field style="width: 100%">
          <mat-label>Color Tema</mat-label>
          <input matInput readonly formControlName="colorTema" />
          <!-- Paleta cerrada: la app no usa el hex tal cual (arma un esquema Material 3),
               así que no se tipea ni se elige un color libre. -->
          <ngx-colors
            matSuffix
            ngx-colors-trigger
            formControlName="colorTema"
            [hideTextInput]="true"
            [hideColorPicker]="true"
            (change)="onColorChange($event, 'colorTema')"
          />
          <mat-hint>
            En la app se ve
            <span
              class="tono-app"
              [style.background]="tonoApp(configuracion.get('colorTema')?.value)"
            ></span>
            (solo colores de la paleta)
          </mat-hint>
        </mat-form-field>

        <mat-form-field style="width: 100%">
          <mat-label>Color Acento (opcional)</mat-label>
          <input matInput readonly formControlName="colorAccent" />
          <ngx-colors
            class="suffix"
            matSuffix
            ngx-colors-trigger
            formControlName="colorAccent"
            (change)="onColorChange($event, 'colorAccent')"
          />
        </mat-form-field>

        <!-- Fuente propia del cliente (OTF/TTF) → URL en configuracion.fuente -->
        <mat-form-field style="width: 100%">
          <mat-label>Fuente (URL)</mat-label>
          <input matInput readonly formControlName="fuente" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="fileInputFuente.click()"
            [disabled]="!nombresValido()"
          >
            <mat-icon>upload</mat-icon>
          </button>
          <input
            #fileInputFuente
            type="file"
            style="position: fixed; top: -20000px"
            accept=".otf,.ttf"
            (change)="subirFuente.emit($event)"
          />
        </mat-form-field>
      </div>

      <div class="row-wrap justify-start align-center gap-15px">
        <!-- ICONO -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'icono'"
          [hint]="hintImg('icono')"
          [label]="'Icono'"
        />

        <!-- LATERAL -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'lateral'"
          [hint]="hintImg('lateral')"
          [label]="'Lateral'"
        />

        <!-- Login / Hero: header de login/registro (hero en plantilla 'hero'). Vacío → icono/lateral. -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'login'"
          [hint]="hintImg('login')"
          [label]="'Login / Hero'"
        />
      </div>
    </div>

    <!-- Imágenes de pantallas y botones de alerta (compartidas con la app web vieja) -->
    <div class="subgrupo" [formGroup]="imagenes">
      <h2>Imágenes</h2>
      <div class="row-wrap justify-start align-center gap-15px">
        <!-- FONDO -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'fondo'"
          [hint]="hintImg('fondo')"
          [label]="'Fondo'"
        />

        <!-- ARRIBA -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'arriba'"
          [hint]="hintImg('arriba')"
          [label]="'Banner superior (arriba)'"
        />

        <!-- ABAJO -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'abajo'"
          [hint]="hintImg('abajo')"
          [label]="'Banner inferior (abajo)'"
        />

        <!-- Sirena -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'sirena'"
          [hint]="hintImg('sirena')"
          [label]="'Sirena'"
        />


        <!-- Reflector -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'reflector'"
          [hint]="hintImg('reflector')"
          [label]="'Reflector'"
        />


        <!-- Adelante -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'adelante'"
          [hint]="hintImg('adelante')"
          [label]="'Adelante'"
        />


        <!-- Atrás -->
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'atras'"
          [hint]="hintImg('atras')"
          [label]="'Atras'"
        />

      </div>
    </div>

    <!-- Instructivo: 3 pasos, imagen + texto. Vacío → default bundleado. -->
    <div class="subgrupo">
      <h2>Instructivo</h2>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'instructivo1'"
          [hint]="hintImg('instructivo1')"
          [label]="'Instructivo 1 (botón)'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto paso 1</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="instructivoTexto1"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'instructivo2'"
          [hint]="hintImg('instructivo2')"
          [label]="'Instructivo 2 (atención)'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto paso 2</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="instructivoTexto2"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'instructivo3'"
          [hint]="hintImg('instructivo3')"
          [label]="'Instructivo 3 (sirena)'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto paso 3</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="instructivoTexto3"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <!-- Pantalla de permisos: imagen + texto por permiso. Vacío → default
         bundleado. Los permisos que se piden los deriva la app de la config (alertas,
         trackeo, multimedia); acá solo se personaliza la explicación. -->
    <div class="subgrupo">
      <h2>Pantalla de permisos</h2>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'permisoUbicacion'"
          [hint]="hintImg('permisoUbicacion')"
          [label]="'Permiso ubicación'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto permiso ubicación</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="permisoUbicacionTexto"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'permisoCamara'"
          [hint]="hintImg('permisoCamara')"
          [label]="'Permiso cámara'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto permiso cámara</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="permisoCamaraTexto"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'permisoMicrofono'"
          [hint]="hintImg('permisoMicrofono')"
          [label]="'Permiso micrófono'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto permiso micrófono</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="permisoMicrofonoTexto"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="row-wrap justify-start align-center gap-15px">
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'permisoNotificaciones'"
          [hint]="hintImg('permisoNotificaciones')"
          [label]="'Permiso notificaciones'"
        />
        <mat-form-field style="flex: 1" [formGroup]="configuracion">
          <mat-label>Texto permiso notificaciones</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="(default si está vacío)"
            formControlName="permisoNotificacionesTexto"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <!-- Menú mobile -->
    <div class="subgrupo">
      <h2>Menú</h2>
      <div class="mb-3" [formGroup]="configuracion">
        <div class="row justify-between align-center gap-3">
          <!-- Boton Mobile 1  -->
          <mat-form-field>
            <mat-label>Botón Mobile 1</mat-label>
            <mat-select formControlName="boton1Mobile">
              @for (c of botonesMobile; track c) {
                <mat-option [value]="c">
                  {{ c }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Boton Mobile 2  -->
          <mat-form-field>
            <mat-label>Botón Mobile 2</mat-label>
            <mat-select formControlName="boton2Mobile">
              @for (c of botonesMobile; track c) {
                <mat-option [value]="c">
                  {{ c }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Boton Mobile 3  -->
          <mat-form-field>
            <mat-label>Botón Mobile 3</mat-label>
            <mat-select formControlName="boton3Mobile">
              @for (c of botonesMobile; track c) {
                <mat-option [value]="c">
                  {{ c }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if (linksMenu) {
        <h3>Links del menú Más</h3>
        <p class="hint">Se abren en el navegador del teléfono. Orden = orden en el menú.</p>
        <div [formGroup]="configuracion">
          <div class="links-menu" formArrayName="linksMenuMobile">
            @for (fila of linksMenu.controls; track fila; let i = $index) {
              <div class="link-card" [formGroupName]="i">
                <div class="link-card__cabecera">
                  <span class="link-card__preview">
                    @if (fila.get('imagen')?.value) {
                      <img [src]="fila.get('imagen')?.value" alt="" />
                    } @else {
                      <span class="ic" [innerHTML]="svgIcono(fila.get('icono')?.value)"></span>
                    }
                  </span>
                  <span class="link-card__titulo">{{ fila.get('nombre')?.value || 'Link ' + (i + 1) }}</span>
                  <button mat-icon-button type="button" [disabled]="i === 0" (click)="moverLink(i, -1)">
                    <mat-icon>arrow_upward</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="i === linksMenu.length - 1"
                    (click)="moverLink(i, 1)"
                  >
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                  <button mat-icon-button type="button" color="warn" (click)="quitarLink(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="nombre" />
                  <mat-error>Obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Link</mat-label>
                  <input matInput formControlName="link" placeholder="https://..." />
                  <mat-error>URL inválida (https://…, tel:…, mailto:… o dominio)</mat-error>
                </mat-form-field>

                <div class="link-card__pie">
                  <mat-form-field subscriptSizing="dynamic" class="link-card__icono">
                    <mat-label>Ícono</mat-label>
                    <mat-select formControlName="icono">
                      <mat-select-trigger>
                        <span class="opcion-icono">
                          <span class="ic" [innerHTML]="svgIcono(fila.get('icono')?.value)"></span>
                          {{ fila.get('icono')?.value || 'Por defecto' }}
                        </span>
                      </mat-select-trigger>
                      <mat-option [value]="null">
                        <span class="opcion-icono">
                          <span class="ic" [innerHTML]="svgIcono(null)"></span> Por defecto
                        </span>
                      </mat-option>
                      @for (ic of iconosLink; track ic) {
                        <mat-option [value]="ic">
                          <span class="opcion-icono">
                            <span class="ic" [innerHTML]="svgIcono(ic)"></span> {{ ic }}
                          </span>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <input
                    #archivoLink
                    type="file"
                    accept="image/*"
                    hidden
                    (change)="subirImagenLink(i, $event)"
                  />
                  @if (fila.get('imagen')?.value) {
                    <button mat-stroked-button type="button" (click)="setImagenLink(i, null)">
                      <mat-icon>close</mat-icon> Quitar imagen
                    </button>
                  } @else {
                    <button
                      mat-stroked-button
                      type="button"
                      [disabled]="!nombresValido() || subiendoLink === fila"
                      (click)="archivoLink.click()"
                    >
                      <mat-icon>upload</mat-icon>
                      {{ subiendoLink === fila ? 'Subiendo…' : 'Imagen' }}
                    </button>
                  }
                </div>
              </div>
            }
            <button
              type="button"
              class="link-card link-card--agregar"
              (click)="agregarLink()"
              [disabled]="!nombresValido()"
            >
              <mat-icon>add</mat-icon> Agregar link
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Módulos / funcionalidades visibles en la app -->
    <div class="subgrupo">
      <h2>Módulos</h2>

      <!-- Contactos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verContactos">
          Mostrar Contactos
        </mat-checkbox>
      </div>

      <!-- Mostrar Reclamos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verReclamos">
          Mostrar Reclamos
        </mat-checkbox>
      </div>

      <!-- Mostrar Eventos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verEventos">
          Mostrar Eventos
        </mat-checkbox>
      </div>

      <!-- Mostrar Eventos Externos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verEventosExternos">
          Mostrar Eventos Externos
        </mat-checkbox>
      </div>

      <!-- Mostrar Turnos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verTurnos">
          Mostrar Turnos
        </mat-checkbox>
      </div>

      <!-- Mostrar Estacionamiento Medido  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verEstacionamientoMedido">
          Mostrar Estacionamiento Medido
        </mat-checkbox>
      </div>

      <!-- Mostrar Colectivos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verColectivos">
          Mostrar Colectivos
        </mat-checkbox>
      </div>

      <!-- Apikey Colectivos  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-form-field>
          <mat-label>Apikey Colectivos</mat-label>
          <input matInput formControlName="apikeyColectivos" />
        </mat-form-field>
      </div>

      <!-- Mostrar Donde Voto -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="verPadron">
          Mostrar Donde Voto
        </mat-checkbox>
      </div>

      <!-- Mostrar Servicios o Trámites -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarServiciosTramites">
          Mostrar Servicios o Trámites
        </mat-checkbox>
      </div>
      @if (configuracion.get("mostrarServiciosTramites")?.value) {
        <div style="margin-top: -0.5em; margin-bottom: 1em">
          <app-servicios-tramites-seccion
            [ids]="idsBtnsServiciosTramites"
            [botonesCatalogo]="botones ?? []"
          />
        </div>
      }

      <!-- Telemedicina -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="tieneTelemedicina"
          >Tiene Telemedicina</mat-checkbox
        >
      </div>

      <!-- Mostrar Mapa -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarMapa">
          Mostrar Mapa
        </mat-checkbox>
      </div>

      <!-- Mostrar Sirenas Offline -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarSirenasOffline">
          Mostrar Sirenas Offline
          <small
            >- Si no está activado no se muestra ningún icono en el mapa (como
            si la sirena no existiera)</small
          >
        </mat-checkbox>
      </div>

      <!-- Mostrar Estado Sirenas -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarEstadoSirenas">
          Mostrar Estado Sirenas
          <small
            >- Muestra de distintos colores si las sirenas estan online u
            offline (si no se activa se ven todas azules)</small
          >
        </mat-checkbox>
      </div>

      <!-- Mostrar Todas Las Sirenas  -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarTodasLasSirenas">
          Mostrar todas las sirenas
        </mat-checkbox>
      </div>

      <!-- Ícono de las sirenas en Cobertura -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-form-field>
          <mat-label>Ícono de las sirenas en el mapa</mat-label>
          <mat-select formControlName="iconoSirenaMapa">
            <mat-select-trigger>
              <span class="opcion-icono">
                @if (!iconoSirenaCustom) {
                  <span class="ic" [innerHTML]="svgSirena(configuracion.get('iconoSirenaMapa')?.value)"></span>
                }
                {{ nombreIconoSirena }}
              </span>
            </mat-select-trigger>
            @for (opcion of opcionesIconoSirena; track opcion.valor) {
              <mat-option [value]="opcion.valor">
                <span class="opcion-icono">
                  @if (opcion.valor !== 'custom') {
                    <span class="ic" [innerHTML]="svgSirena(opcion.valor)"></span>
                  }
                  {{ opcion.nombre }}
                </span>
              </mat-option>
            }
          </mat-select>
          <mat-hint>Mapa de Cobertura de la app. Salvo la imagen propia, toman el color del estado de la sirena</mat-hint>
        </mat-form-field>
      </div>
      @if (iconoSirenaCustom) {
        <app-upload-image
          [disabled]="!nombresValido()"
          [formulario]="formulario"
          [formGroup]="imagenes"
          [controlName]="'sirenaMapa'"
          [accept]="'image/png'"
          [minLadoPx]="192"
          [maxBytes]="1000000"
          [hint]="'Solo PNG con fondo transparente. Mínimo 192 × 192 px (cuadrado), máximo 1 MB. Se ancla abajo al centro'"
          [label]="'Ícono sirena (mapa)'"
        />
      }

      <!-- Localidades en Cobertura -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarLocalidadesCobertura">
          Mostrar localidades en Cobertura
          <small
            >- Dibuja en el mapa de la app los polígonos de las localidades del
            cliente</small
          >
        </mat-checkbox>
      </div>

      <!-- Notificacion uso de sirenas -->
      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="notificacionesSirenas">
          Notificacion de uso de sirenas
          <small
            >- Envia a los vecinos con domicilio cercano a la sirena una
            notificacion cuando se detona</small
          >
        </mat-checkbox>
      </div>
    </div>

    <!-- EULA -->
    <div class="subgrupo">
      <h2>Términos y Condiciones</h2>

      <div class="mb-3" [formGroup]="configuracion">
        <mat-checkbox formControlName="mostrarEula">
          Mostrar Términos y Condiciones (EULA)
        </mat-checkbox>
      </div>

      @if (configuracion.get("mostrarEula")?.value) {
        <div style="margin-top: 1em">
          <app-md-editor
            [formControl]="$any(configuracion.get('textoEula'))"
            [placeholder]="
              'Escriba aquí el contenido de los términos y condiciones en formato Markdown...'
            "
            [height]="'250px'"
          />
        </div>
      }
    </div>
  </ng-container>
}
